import styled from 'styled-components'

import { UserBadgeSize } from './UserBadge.types'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const BadgeContainer = styled.div<{ size: UserBadgeSize; onClick?: () => void }>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ size }) => (size == 'large' ? 42 : size == 'medium' ? 24 : 20)}px;
  height: ${({ size }) => (size == 'large' ? 42 : size == 'medium' ? 24 : 20)}px;

  border-radius: 50%;

  overflow: hidden;

  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`

export const ShortUsernameLabel = styled.span<{ size: UserBadgeSize }>`
  line-height: ${({ size }) => (size == 'large' ? 14 : size == 'medium' ? 10 : 8)}px;
  font-size: ${({ size }) => (size == 'large' ? 14 : size == 'medium' ? 10 : 8)}px;
  font-style: normal;
  font-weight: 500;
  color: var(--foreground-neutral, #14171f);
`

export const UsernameLabel = styled.span<{ size: UserBadgeSize }>`
  font-size: ${({ size }) => (size == 'large' ? 16 : size == 'medium' ? 14 : 12)}px;
  font-style: normal;
  font-weight: 400;
  color: var(--foreground-neutral, #14171f);
  padding: 0 8px;
  box-sizing: border-box;
`
